export default "__VITE_ASSET__ChIx0QaW__"